import React from "react";
import { useNavigate } from "react-router-dom";

import { HubButton } from "../../../components";
import { FormRow, SectionLabel } from "../components";
import { StyledFormCard } from "../styles";

const SecurityTab = () => {
  const navigate = useNavigate();

  return (
    <StyledFormCard>
      <SectionLabel>Password</SectionLabel>
      <FormRow
        label="Reset password"
        helper="Passwords rotate through the reset-password flow. No one (including admins) can set a password directly — clicking sends a reset link."
      >
        <HubButton
          variant="contained"
          size="xsmall"
          label="Send reset link"
          onClick={() => navigate("/reset")}
        />
      </FormRow>
    </StyledFormCard>
  );
};

export default SecurityTab;
